module.exports = __webpack_public_path__ + "img/login-logo.e620bd12.png";